import type { IconProps } from "./types";

const CheckIcon = ({
  width,
  size,
  height,
  style: _style,
  color,
  noPointer,
  title,
  ...props
}: IconProps) => (
  <svg
    {...props}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 16 12"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
    stroke={color || "var(--color-easil-gray-x-dark)"}
    data-testid="CheckIcon"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-4-6h24v24H-4z" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15 1L5.345 11 1 7"
      />
    </g>
  </svg>
);

export default CheckIcon;
